import LookVirtualizedListLoadingItem
  from "../../../../../../../look/lookNavigation/lookMain/lookCategory/lookVirtualizedListLoadingItem";
import {Grid} from "react-virtualized";
import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

export const SqftOptionsLoading = (props) => {
  const {isMobile, windowHeight} = props;

  const rowHeight = 135;
  const width = isMobile ? 221 : 280;
  const columnWidth = width;
  const columnCount = 1;
  const height = isMobile ? windowHeight - 25 : windowHeight - 60;
  const rowCount = Math.floor(height / rowHeight);

  const listSettings = {
    width,
    columnCount,
    columnWidth,
    rowCount,
    height,
    rowHeight: rowHeight,
    overscanRowCount: 3,
    showScrollingPlaceholder: false,
    useDynamicRowHeight: false,
  }

  const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    void columnIndex;
    void rowIndex;

    return <LookVirtualizedListLoadingItem style={style} key={key}/>
  }

  const noRowsRenderer = () => <div className={"ass-list"}>No Features found</div>;

  return (
    <Grid
      // ref="List"
      width={listSettings.width}
      height={listSettings.height}
      //onScroll={onScrollHandler}
      overscanRowCount={listSettings.overscanRowCount}
      rowCount={listSettings.rowCount}
      columnCount={listSettings.columnCount}
      columnWidth={listSettings.columnWidth}
      rowHeight={listSettings.rowHeight}
      cellRenderer={cellRenderer}
      noRowsRenderer={noRowsRenderer}
    />
  )
}

SqftOptionsLoading.propTypes = {
  // maxClickCountReached: PropTypes.func,
  // renderList: PropTypes.array,
  // contentHeight: PropTypes.number,
   isMobile: PropTypes.bool,
  // onScrollHandler: PropTypes.func,
  // loadingCount: PropTypes.number,
}

const mapStateToProps = (store) => {
  const {windowHeight, isMobile} = store.serverState;
  return {
    windowHeight,
    isMobile,
  };
};

const mapDispatchToProps = {
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftOptionsLoading);
